import { render } from "./UsersChatPage.vue?vue&type=template&id=59b7cd36&scoped=true"
import script from "./UsersChatPage.vue?vue&type=script&lang=js"
export * from "./UsersChatPage.vue?vue&type=script&lang=js"

import "./UsersChatPage.vue?vue&type=style&index=0&id=59b7cd36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b7cd36"]])

export default __exports__